import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Play } from 'lucide-react';
import { trackAppDownload } from '../../services/analytics';
import '../../styles/website/Header.css';

const WebsiteHeader = () => {
  const navigate = useNavigate();

  const handleWatch = () => {
    localStorage.removeItem('past_story_viewed');
    localStorage.removeItem('free_story_used');
    localStorage.removeItem('onboarding_completed');
    localStorage.removeItem('story_generated');
    localStorage.removeItem('story_generation_in_progress');
    navigate('/onboarding-new?source=watch');
  };

  return (
    <header className="app-header" data-testid="website-header">
      <div className="header-content">
        <Link to="/watch" className="logo-link">
          <div className="logo-stars-arc">
            <svg viewBox="0 0 200 35" className="header-stars-svg">
              <defs>
                <linearGradient id="headerStarGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{ stopColor: '#4ecdc4', stopOpacity: 1 }} />
                  <stop offset="25%" style={{ stopColor: '#00f5ff', stopOpacity: 1 }} />
                  <stop offset="50%" style={{ stopColor: '#00f5ff', stopOpacity: 1 }} />
                  <stop offset="75%" style={{ stopColor: '#5b8fd8', stopOpacity: 1 }} />
                  <stop offset="100%" style={{ stopColor: '#8b7dd8', stopOpacity: 1 }} />
                </linearGradient>
              </defs>
              <path d="M 20 25 l 2 -6 l 2 6 l -5.5 -4 l 7 0 z" fill="url(#headerStarGradient)" />
              <path d="M 60 15 l 2.5 -7.5 l 2.5 7.5 l -7 -5 l 9 0 z" fill="url(#headerStarGradient)" />
              <path d="M 100 8 l 3 -9 l 3 9 l -8 -6 l 10 0 z" fill="url(#headerStarGradient)" />
              <path d="M 140 15 l 2.5 -7.5 l 2.5 7.5 l -7 -5 l 9 0 z" fill="url(#headerStarGradient)" />
              <path d="M 180 25 l 2 -6 l 2 6 l -5.5 -4 l 7 0 z" fill="url(#headerStarGradient)" />
            </svg>
          </div>
          <span className="logo-text">taraanaya</span>
        </Link>
        <div className="header-right">
          <nav className="nav-menu">
            <a href="/about#domains" className="nav-link">Domains</a>
            <a href="/about#b2b" className="nav-link">Business</a>
            <a href="/about#matchmaking" className="nav-link">Matchmaking</a>
            <a href="/about#power" className="nav-link">Destiny</a>
            <a href="/about#contact" className="nav-link">Contact</a>
          </nav>
          <button onClick={handleWatch} className="watch-story-btn" data-testid="header-watch-btn">
            <Play size={16} fill="#000820" />
            <span>Watch Your Story</span>
          </button>
          <div className="app-store-buttons">
            <a href="#" className="app-store-btn apple-store" onClick={() => trackAppDownload('ios')}>
              <svg viewBox="0 0 24 24" className="store-icon">
                <path fill="currentColor" d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              <div className="store-text">
                <span className="store-label">Download on the</span>
                <span className="store-name">App Store</span>
              </div>
            </a>
            <a href="#" className="app-store-btn google-play" onClick={() => trackAppDownload('android')}>
              <svg viewBox="0 0 24 24" className="store-icon">
                <path fill="currentColor" d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              <div className="store-text">
                <span className="store-label">GET IT ON</span>
                <span className="store-name">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default WebsiteHeader;
